module.exports = __webpack_public_path__ + "static/media/pantalla-login.9479f893.jpg";